import React from 'react';
import { Spinner } from '@/components/ui/spinner';

const Loading: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Spinner
    animation="border"
    style={{
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      margin: 'auto',
    }}
  />
);

export default Loading;
